import { render, staticRenderFns } from "./QuestionsTab.vue?vue&type=template&id=5bc2f563&scoped=true"
import script from "./QuestionsTab.vue?vue&type=script&lang=js"
export * from "./QuestionsTab.vue?vue&type=script&lang=js"
import style0 from "./QuestionsTab.vue?vue&type=style&index=0&id=5bc2f563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2f563",
  null
  
)

export default component.exports